/* unplugin-vue-components disabled */import { render } from "./AuthItemsTable.vue?vue&type=template&id=03319f18&scoped=true&ts=true"
import script from "./AuthItemsTable.vue?vue&type=script&lang=ts"
export * from "./AuthItemsTable.vue?vue&type=script&lang=ts"

import "./AuthItemsTable.vue?vue&type=style&index=0&id=03319f18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03319f18"]])

export default __exports__